/* eslint new-cap: 0 */

import React from 'react';
import { Route } from 'react-router';

/* containers */
import { App } from './containers/App';
import LoginView from './components/LoginView';
import RegisterView from './components/RegisterView';
import NotFound from './components/NotFound';
import LandingView from './components/LandingView'
import { DetermineAuth } from './components/DetermineAuth';
import { requireAuthentication } from './components/AuthenticatedComponent';
import { UserSettingsView} from './components/UserSettings'

export default (
    <Route path="/" component={App}>
        <Route path="main" component={requireAuthentication(LandingView)} />
        <Route path="login" component={LoginView} />
        {/* <Route path="register" component={RegisterView} /> */}
        <Route path="user_settings" component={requireAuthentication(UserSettingsView)} />
        <Route path="*" component={DetermineAuth(NotFound)} />
    </Route>
);




// WEBPACK FOOTER //
// ./src/routes.js